// extracted by mini-css-extract-plugin
export default {"listSummaryWrapper":"iQEHwK9FfXV4nL__HLsP","list":"OXa7Zry0lepdlA2CAPBW"};